import React, { useEffect, useState } from 'react'
import { Image, Message, Form } from 'semantic-ui-react'
import api from '../../api/installation-and-integration/servicetitan';
import { useSelector, useDispatch } from 'react-redux';
import { setPageTitle, toggleNavigation, setBreadCrum, setMessage, toggleBreadcrum } from '../../store/Page';
import Modal from "../Pages/ChatSetup/components/Modal";
import "./integration.css"

const  ServiceTitanLogs = () => {
    const dispatch = useDispatch();

    const PageMessage = useSelector((state) => state.page.message);
    const user = useSelector((state) => state.user.company);
    const [logs, setlogs] = useState([]);
    const [loading, setloading] = useState(false);
    const [search, setsearch] = useState("");
    const [module, setmodule] = useState("");
    // Pagination state variables
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [recordsPerPage] = useState(10);
    const [showPayloadoption, setshowPayloadoption] = useState(false);
    const [payload, setpayload] = useState({});
    useEffect(()=>{
        dispatch(setPageTitle({ title: "Service Titan Logs", subHeaderTitle: "Service Titan Logs" }));
        dispatch(setBreadCrum({ breadcrum: null }));
        //dispatch(setMessage("Service Titan Logs"));
        dispatch(toggleBreadcrum({ toggle: false }));
        dispatch(toggleNavigation({ toggle: false }));
        //set page title
        document.title = "Service Titan Logs";
        console.log("Service Titan Logs");
        //get query params module
        const module = new URLSearchParams(window.location.search).get('module');
        document.title = "Service Titan Logs for "+module.charAt(0).toUpperCase() + module.slice(1);
        setmodule(module);
        console.log(module,"servicetitanservicetitan");
        getLogs(module,'', 1, '');
        //cleanup
        return ()=>{
            setlogs([]);
            setloading(false);
        }
    },[]);

    const getLogs = async (module, search, page = 1) => {
        setloading(true);
        console.log(module,search,"module and search"); 
        //get timezone from browser
        let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
        let timezone = u.substring(0, 3) + ":" + u.substring(3, u.length);
        console.log(timezone,"timezone");
        // create api in in src\api\installation-and-integration\servicetitan.js
        api.getLogs({
            module: module,
            timezone: timezone,
            search: search,
            page: page,
            limit: recordsPerPage
        }).then((res)=>{
           console.log(res.data,"res for service titan logs");
            if(res.status){
                setlogs(res.data.logs || res.data);
                setTotalPages(res.data.totalPages || 1);
                setTotalRecords(res.data.totalRecords || res.data.length);
                setCurrentPage(page);
            }
      
        
       }).catch((err)=>{
        console.log(err);
       });
           setloading(false);
    }

    const searchLogs = async (e,search) => {
        e.preventDefault();
          setCurrentPage(1); // Reset to first page when searching
          getLogs(module, search, 1);
    }

    const debounce = (func, delay) => {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    };

    const setSearchParams = (search) => {
      setsearch(search);
      if(search.length==0){
        setCurrentPage(1); // Reset to first page when clearing search
        getLogs(module,'', 1);
      }
    }

    // Pagination functions
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            getLogs(module, search, page);
        }
    }
    
    const bodyforpayload=(payload)=>{
       console.log(payload,"payload",typeof payload);
        // break payload in columns and rows 

         let payloadarray=payload && typeof payload === 'string' ? JSON.parse(payload) : [];
         console.log(payloadarray.length,"payloadarray",payloadarray);
         if(Object.entries(payloadarray).length>0){
            return(<div>
                <table id="stpayloadlog" className="table table-bordered" style={{height:'300px',overflowY:'auto'}}>
                    <thead>
                        <tr>
                            <th>Key</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody style={{maxHeight:'300px',overflowY:'auto'}}>
                        {Object.entries(payloadarray).map((item,index)=>{
                            return <tr key={index}>
                                <td>{item[0]}</td>
                                <td>{typeof item[1] === 'object' ? JSON.stringify(item[1]) : item[1]}</td>
                            </tr>
                        })}
                           
                    </tbody>
                </table>
            </div>);
         }
         return <div>No payload found</div>
    }

    const renderPagination = () => {
        const pages = [];
        const maxVisiblePages = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        
        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        // First item button
        pages.push(
            <a 
                key="first" 
                aria-current="false" 
                aria-disabled={currentPage === 1} 
                tabIndex="0" 
                value="1" 
                aria-label="First item" 
                type="firstItem" 
                className={`item ${currentPage === 1 ? 'disabled' : ''}`}
                onClick={() => handlePageChange(1)}
                style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
            >
                «
            </a>
        );

        // Previous button
        pages.push(
            <a 
                key="prev" 
                aria-current="false" 
                aria-disabled={currentPage === 1} 
                tabIndex="0" 
                value={currentPage - 1} 
                aria-label="Previous item" 
                type="prevItem" 
                className={`item ${currentPage === 1 ? 'disabled' : ''}`}
                onClick={() => handlePageChange(currentPage - 1)}
                style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
            >
                ⟨
            </a>
        );

        // First page
        if (startPage > 1) {
            pages.push(
                <a 
                    key="first-page" 
                    aria-current="false" 
                    aria-disabled="false" 
                    tabIndex="0" 
                    value="1" 
                    type="pageItem" 
                    className="item"
                    onClick={() => handlePageChange(1)}
                >
                    1
                </a>
            );
            if (startPage > 2) {
                pages.push(
                    <a 
                        key="dots1" 
                        aria-current="false" 
                        aria-disabled="true" 
                        tabIndex="-1" 
                        type="pageItem" 
                        className="item disabled"
                        style={{ cursor: 'not-allowed' }}
                    >
                        ...
                    </a>
                );
            }
        }

        // Page numbers
        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <a 
                    key={i} 
                    aria-current={currentPage === i ? "true" : "false"} 
                    aria-disabled="false" 
                    tabIndex="0" 
                    value={i} 
                    type="pageItem" 
                    className={`${currentPage === i ? 'active ' : ''}item`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </a>
            );
        }

        // Last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pages.push(
                    <a 
                        key="dots2" 
                        aria-current="false" 
                        aria-disabled="true" 
                        tabIndex="-1" 
                        type="pageItem" 
                        className="item disabled"
                        style={{ cursor: 'not-allowed' }}
                    >
                        ...
                    </a>
                );
            }
            pages.push(
                <a 
                    key="last-page" 
                    aria-current="false" 
                    aria-disabled="false" 
                    tabIndex="0" 
                    value={totalPages} 
                    type="pageItem" 
                    className="item"
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </a>
            );
        }

        // Next button
        pages.push(
            <a 
                key="next" 
                aria-current="false" 
                aria-disabled={currentPage === totalPages} 
                tabIndex="0" 
                value={currentPage + 1} 
                aria-label="Next item" 
                type="nextItem" 
                className={`item ${currentPage === totalPages ? 'disabled' : ''}`}
                onClick={() => handlePageChange(currentPage + 1)}
                style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
            >
                ⟩
            </a>
        );

        // Last item button
        pages.push(
            <a 
                key="last" 
                aria-current="false" 
                aria-disabled={currentPage === totalPages} 
                tabIndex="0" 
                value={totalPages} 
                aria-label="Last item" 
                type="lastItem" 
                className={`item ${currentPage === totalPages ? 'disabled' : ''}`}
                onClick={() => handlePageChange(totalPages)}
                style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
            >
                »
            </a>
        );

        return pages;
    }
    const showPayload=(payload)=>{
        console.log(payload,"payload");
        //show payload in a modal
        setshowPayloadoption(true);
        setpayload(payload);
    }

    return(
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
          <div className="kt-content kt-grid__item kt-grid__item--fluid">
            <div className="yr-body-p yr-mt-20">
               
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="kt-portlet shadow-none">
                    <div className="kt-portlet__body yr-pd0-lr">
                            {loading && <div className="kt-spinner kt-spinner--lg kt-spinner--center">Loading...</div>}
                        {/* ui for search by call_id and user_id */}
                        <div className="row" style={{marginBottom:'15px',marginLeft:'10px',marginRight:'10px'}}>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <form id="searchchat" className="form-inline" onSubmit={(e)=>searchLogs(e,search)}>
                                    <div> 
                                        <div className="kt-input-icon kt-input-icon--right header-search kt-input-icon--right" style={{width:'290px'}}>
                                            <input 
                                                style={{width:'284px',height:'44px'}} 
                                                type="text"  
                                                className="form-control" 
                                                placeholder={module=='call' ? `Search by call log id` : `Search by chat id`} 
                                                id="generalSearch" 
                                                name="q" 
                                                data-has-listeners="true" 
                                                value={search} 
                                                onChange={(e)=>setSearchParams(e.target.value)} 
                                            />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--right"></span>
                                        </div>
                                    </div>
                                    <button className="btn linear-gradient yr-submitbtn btn-sm">Search</button>
                                </form>
                            </div>
                        </div>

                        {logs.length>0 ?
                        <> 
                        <table className="table table-bordered">
                        <thead>
                            {/* add sortable by created_at and search by call_id and user_id*/}
                            <tr>
                              <th className='col-md-2'>{module === 'call' ? 'Call Log ID' : 'Chat ID'}</th>
                            <th className='col-md-2'>Date/Time</th>
                            <th className='col-md-6'>Reason</th>
                            <th className='col-md-2'>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                            {logs.map((log)=>(
                              //create a table with 4 columns id,call_id,user_id,created_at,message,module,status
                            //  devide column width equally
                                  <tr key={log.id}>
                                    <td className='col-md-2'>{log.call_id}</td>
                                    <td className='col-md-2'>{log.created_at}</td>
                                    {/* break long message in 2 lines */}
                                    <td className='col-md-6'>{<div className="text-wrap">{log.message}</div>}
                                    {/* show json payload on tooltip when user click on i icon*/}
                                    {log.payload ? <i title="View Payload" className="fa fa-info-circle" style={{cursor:'pointer'}} onClick={()=>showPayload(log.payload)}></i>:<></>}
                                    </td>
                                    {/*highlight the status if it is error or success   */}   
                                    <td className='col-md-2'>{log.status === 'Failed' ? <span className="badge badge-danger">{log.status}</span> : <span className="badge badge-success">{log.status}</span>}</td>
                                  </tr>
                            
                            ))}
                            </tbody>
                            </table>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="text-muted">
                                                Showing {((currentPage - 1) * recordsPerPage) + 1} to {Math.min(currentPage * recordsPerPage, totalRecords)} of {totalRecords} entries
                                            </div>
                                            <div aria-label="Pagination Navigation" role="navigation" className="ui pagination menu">
                                                {renderPagination()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                         </>
                        :<div className="kt-spinner kt-spinner--lg kt-spinner--center">No logs found</div>}  
                    </div>
                  </div>  
                </div>
              </div>
            </div>
          </div>
          <Modal
                        show={showPayloadoption}
                        footer={""}
                        title={"Payload"}
                        onclose={()=>setshowPayloadoption(false)}
                        body={bodyforpayload(payload)}
                        maxWidth={700}
                    />
        </div>
      );
}

  export default ServiceTitanLogs;